import React,{useState} from "react";
import { Link } from "react-router-dom";
// import "./CustomerPrfoile.css";
import { registerCustomer } from "../../redux/CustomerReducer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { editCustomer } from "../../redux/CustomerReducer";
import Swal from 'sweetalert2'
import './CustomerProfile.css'
import { useSelector } from "react-redux";
const CustomerPrfoile = () => {

    const currentUser=useSelector((state)=>state?.CustomerReducer?.currentCustomer?.user)

    console.log("currentUser",currentUser)
  const dispatch=useDispatch();
  const navigate=useNavigate();

    const[user,setUser]=useState(
        {
            email:currentUser?.email,
            name:currentUser?.name,
            phone:currentUser?.phone,
            password:"",
            userType:"Customer"
        }
    )

    const handleChange=(e)=>{

        const{name,value}=e.target

        setUser(
            {
                ...user,[name]:value
            }
        )
    }

    console.log("user",user)

    const signupClicked=async()=>{

        let id=currentUser._id;
        let idData={
            id:currentUser._id
        }
        console.log("idClicked",id)
      const response=await dispatch(editCustomer({user,idData}))


    //   console.log("response",response?.payload?.data?.message)
      console.log("response",response?.payload.message)

      Swal.fire(
        'Good',
        response?.payload.message,
        'success'
      )


        if(response?.payload?.success)
        {

        //   navigate("/customer/login")
        }


    }

  return (
    <div className="mainContainerLogin mainContainerSignup mainContainerProfile">
      <div className="userLoginTxt userLoginTxtProfile">You can edit your profile here..</div>

      <div className="topRowFieldsSignup topRowFieldsSignupProfile">
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile" >
          <div className="inputTxtLogin">Email</div>
          <input
            className="inputLogins inputSignup"
            type="email"
            placeholder="Enter Email"
            value={user.email}

            onChange={handleChange}
            name="email"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin">Name</div>
          <input
            className="inputLogins inputSignup"
            type="text"
            placeholder="Enter Name"
            value={user.name}

            onChange={handleChange}
            name="name"
          />
        </div>
      </div>
      <div className="topRowFieldsSignup topRowFieldsSignupProfile">
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin">Mobile Number</div>
          <input
            className="inputLogins inputSignup"
            // type="number"
            placeholder="Enter Mobile Number"
            value={user.phone}
            onChange={handleChange}
     
            name="phone"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup topInputFieldProfile">
          <div className="inputTxtLogin"
          type="password"
          
          >Password</div>
          <input
            className="inputLogins inputSignup"
            type="password"
            placeholder="Enter Password"
            onChange={handleChange}
            name="password"
          />
        </div>
      </div>


      <button className="loginBtn saveBtnProfile"
      onClick={signupClicked}
      >Save</button>

    
    </div>
  );
};

export default CustomerPrfoile;
